import { withoutTrackingPageShipmentSelection } from "@redotech/order-tracking-common/tracking-page-shipment-link";
import { useLocation, useNavigate, useParams } from "react-router-dom";

/**
 * Opens a shipment on the tracking page by its index. Relative navigation works
 * in both the customer portal (/orders/:id/track/:fulfillmentIndex) and the
 * embedded tracking routes. The query is kept, minus any shipment selection
 * that would override the path, because embedded pages carry their auth token
 * there.
 */
export function useNavigateToShipment(): (index: number) => void {
  const navigate = useNavigate();
  const { search } = useLocation();
  const { fulfillmentIndex } = useParams<{ fulfillmentIndex?: string }>();
  return (index: number) => {
    const pathname =
      fulfillmentIndex !== undefined ? `../${index}` : `./${index}`;
    navigate(
      { pathname, search: withoutTrackingPageShipmentSelection(search) },
      { relative: "path" },
    );
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
}
